import { useState } from "react";
import { useDispatch } from "react-redux";

import { LabOrder } from "pwapi";

import { cancelLabOrder } from "shared/actions/labOrdersActions";

import { PathologyWatchButton } from "components/customInputs/buttons/Button";

import WarningDialog from "../WarningDialog";

const OrderCancellationButton = ({ order }: { order: LabOrder }) => {
  const dispatch = useDispatch();

  const [isWarningOpen, setIsWarningOpen] = useState<boolean>(false);

  const onHandleConfirm = () => {
    dispatch(cancelLabOrder(order)).then(() => setIsWarningOpen(false));
  };

  return (
    <>
      {isWarningOpen && (
        <WarningDialog
          onClose={() => setIsWarningOpen(false)}
          title="Cancel this order"
        >
          <div className="CaseWarningDialog">
            <p>Cancel this lab order?</p>
            {/* {hasDeleteError && (
            <p className="errorMessage">
              Unexpected error occurred while attempting to delete this block.{" "}
              Please contact support to identify the issue.
              <br />
              <a href="mailto@support@pathologywatch.com">
                support@pathologywatch.com
              </a>
            </p>
          )} */}
            <div className="actions__container">
              <PathologyWatchButton onClick={() => setIsWarningOpen(false)}>
                Cancel
              </PathologyWatchButton>
              <PathologyWatchButton
                type="submit"
                color="red"
                testId="order_confirm_cancel"
                onClick={() => onHandleConfirm()}
              >
                Confirm
              </PathologyWatchButton>
            </div>
          </div>
        </WarningDialog>
      )}
      <PathologyWatchButton onClick={() => setIsWarningOpen(true)} size="small">
        Cancel Order
      </PathologyWatchButton>
    </>
  );
};

export default OrderCancellationButton;
